"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTemplate = void 0;
const ExclamationMIcon_1 = require("@alfalab/icons-glyph/ExclamationMIcon");
const InternetOffMIcon_1 = require("@alfalab/icons-glyph/InternetOffMIcon");
const ScrewdriverPaintBrushMIcon_1 = require("@alfalab/icons-glyph/ScrewdriverPaintBrushMIcon");
const templates = {
    INTERNAL: {
        title: 'Ошибка загрузки',
        errorMessage: 'Не удалось загрузить данные',
        Icon: ExclamationMIcon_1.ExclamationMIcon,
        buttonMessage: 'Обновить',
    },
    BUSINESS: {
        title: 'Ошибка загрузки',
        errorMessage: 'Не удалось загрузить данные',
        Icon: ExclamationMIcon_1.ExclamationMIcon,
        buttonMessage: 'Обновить',
    },
    NETWORK: {
        title: 'Нет подключения к сети',
        errorMessage: 'Проверьте ваш доступ к интернету',
        Icon: InternetOffMIcon_1.InternetOffMIcon,
        buttonMessage: 'Обновить',
    },
};
const webViewTemplates = {
    INTERNAL: {
        title: 'Ошибка загрузки',
        errorMessage: 'Не удалось загрузить данные',
        Icon: ExclamationMIcon_1.ExclamationMIcon,
        buttonMessage: 'Обновить',
    },
    BUSINESS: {
        title: 'Не получилось загрузить',
        errorMessage: 'Уже узнаём, в чём дело, и чиним.\n Попробуйте зайти позже',
        Icon: ScrewdriverPaintBrushMIcon_1.ScrewdriverPaintBrushMIcon,
        buttonMessage: 'Понятно',
    },
    NETWORK: {
        title: 'Потеряли связь с вами',
        errorMessage: 'Проверьте подключение к интернету и попробуйте снова',
        Icon: InternetOffMIcon_1.InternetOffMIcon,
        buttonMessage: 'Попробовать ещё раз',
    },
};
const getTemplate = (type, isWebView) => {
    if (isWebView)
        return webViewTemplates[type];
    return templates[type];
};
exports.getTemplate = getTemplate;
